import './App.css';
import React, { useState, useEffect } from 'react';

function App() {
  const [artData, setArtData] = useState([]); // initially empty
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalImage, setModalImage] = useState(null);
  const [infoTab, setInfoTab] = useState("artwork");

  // ===============================
  // SafeImage component - handles missing/failing images
  // ===============================
const SafeImage = ({ src, alt, className, onClick, onLoad }) => {
    const [imgSrc, setImgSrc] = useState(null);

    useEffect(() => {
      if (!src || src.trim() === "") {
        setImgSrc(null);
        return;
      }

      const img = new Image();
      img.src = src;

      img.onload = () => setImgSrc(src);
      img.onerror = () => setImgSrc(null); // hides broken images completely
    }, [src]);

    if (!imgSrc) return null;

    return (
      <img
        src={imgSrc}
        alt={alt}
        className={className}
        onClick={onClick}
        onLoad={onLoad}   // 👈 THIS is the missing link
        loading="lazy"
      />
    );
  };
// Insert relevant const here
const [savedScroll, setSavedScroll] = useState(0);

const handleThumbnailClick = (i) => {
  setSavedScroll(window.scrollY);
  setSelectedIndex(i);
};


// <<< ADD HERE around line 45
const handleSubmit = (e) => {
  e.preventDefault(); // stops the page from reloading
  const form = e.target;
  const name = form.name.value;
  const email = form.email.value;
  const size = form.size.value;
  const notes = form.notes.value;

  const body = `Name: ${name}%0AEmail: ${email}%0ASize: ${size}%0ANotes: ${notes}`;

  window.location.href = `mailto:l8ncook@gmail.com?subject=Commission Request&body=${body}`;
};

  // ===============================
  // Fetch artData JSON
  // ===============================
  useEffect(() => {
    fetch('/art/artData.json')
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then(data => {
        console.log("Loaded artData:", data); // debug
        setArtData(data);
      })
      .catch(err => console.error('Error loading artData:', err));
  }, []);

  // ===============================
  // Clean process/reference images for selected artwork
  // ===============================
  const selectedArt = artData[selectedIndex];

  const cleanProcessImages = selectedArt?.process?.filter(
    img => img && img.trim() !== ""
  );

  const cleanReferenceImages = selectedArt?.referenceImages?.filter(
    img => img && img.trim() !== ""
  );

  const shippingRates = {
  "11x14": 12,
  "12x12": 12,
  "14x20": 15,
  "16x16": 15,
  "18x24": 20,
  "20x24": 25
  };
  // const shippingCost = shippingRates[selectedArt.size] || 12; // default if unknown
  // ===============================
  // JSX
  // ===============================
  return (
    <div className="App">
      <header>
        {/* <h1>L8nArt</h1> */}
        <img src="/art/L8NART_Black_White.jpg" alt="L8NART" className="header-image" />
        <div className="info-tabs-top">
          <button
            className={infoTab === "artwork" ? "active" : ""}
            onClick={() => setInfoTab("artwork")}
          >
            Artwork
          </button>
          <button
            className={infoTab === "commissions" ? "active" : ""}
            onClick={() => setInfoTab("commissions")}
          >
            Commissions
          </button>

          <button
            className={infoTab === "support" ? "active" : ""}
            onClick={() => setInfoTab("support")}
          >
            Support Cats
          </button>
        </div>
      </header>

      <div className="main">
        {/* Left gallery */}
        {infoTab === "artwork" && (
          <div className="gallery-column">
            {artData.map((art, i) => (
              <SafeImage
                key={i}
                src={art.image || `/art/${art.title?.replace(/\s/g,'')}.jpg`}
                alt={art.title || "artwork"}
                className={`thumbnail ${selectedIndex === i ? "selected" : ""}`}
                onClick={() => handleThumbnailClick(i)}
              />
            ))}
          </div>
        )}

        {/* Right info panel */}
        <div className="info-column">
       {infoTab === "artwork" ? (
  selectedIndex !== null && selectedArt ? (
    <>
      {/* calculate shipping safely */}
      {(() => {
        const shippingCost = shippingRates[selectedArt?.size] || 12;
        return (
          <>
            {/* Art frame + artwork */}
            <div className="art-frame" onClick={() => setModalImage(selectedArt.image)}>
              <SafeImage
                src={
                  selectedArt.orientation === "portrait"
                    ? "/frames/portrait-frame.png"
                    : selectedArt.orientation === "landscape"
                    ? "/frames/landscape-frame.png"
                    : "/frames/square-frame.png"
                }
                alt="frame"
                className="frame-image"
              />
              <SafeImage
                src={selectedArt.image}
                alt={selectedArt.title}
                className="selected-art"
                onLoad={() => {
                  window.scrollTo(0, savedScroll);
                }}
              />
            </div>

            {/* Art details */}
            <h2>{selectedArt.title}</h2>
                        <hr></hr>

            <p><strong>Size:</strong> {selectedArt.size}</p>
            <p><strong>Medium:</strong> {selectedArt.medium}</p>
            <p><strong>Price:</strong> ${selectedArt.price}</p>
            <p style={{ fontSize: "0.9em", color: "#61dafb" }}>
              💛 A portion of proceeds supports local cat rescue
            </p>

            {/* Buy Original */}
            {selectedArt?.inventory > 0 ? (
              <a
                href={selectedArt.buyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="buy-button"
              >
                Buy Original
              </a>
            ) : (
              <p style={{ color: 'red' }}>Sold Out</p>
            )}

            {/* Buy Print */}
            {selectedArt?.printLink && (
              <a
                href={selectedArt.printLink}
                target="_blank"
                rel="noopener noreferrer"
                className="buy-button"
              >
                Buy Mini Print ({selectedArt.printPrice})
              </a>
              
            )}
            
            <p><strong>Shipping:</strong></p>
            <p>Mini Prints - 🚚 US shipping included</p>
            <p>Artwork Shipping invoiced separately</p>
            <p><strong>Estimated Shipping Cost:</strong> ${shippingCost}</p>
            {/* Story */}
            {selectedArt?.story && (
              <section className="story-section">
                <h3>Story</h3>
                <p>{selectedArt.story}</p>
              </section>
            )}

            {/* Process photos */}
            {cleanProcessImages?.length > 0 && (
              <section className="process-photos">
                <h3>Process</h3>
                {cleanProcessImages.map((img, i) => (
                  <SafeImage
                    key={i}
                    src={img}
                    alt={`Process step ${i + 1}`}
                    className="process-thumbnail"
                    onClick={() => setModalImage(img)}
                  />
                ))}
              </section>
            )}

            {/* Reference / original photos */}
            {cleanReferenceImages?.length > 0 && (
              <section className="reference-photos">
                <h3>Reference / Original Photos</h3>
                {cleanReferenceImages.map((img, i) => (
                  <SafeImage
                    key={i}
                    src={img}
                    alt={`Reference ${i + 1}`}
                    className="process-thumbnail"
                    onClick={() => setModalImage(img)}
                  />
                ))}
              </section>
            )}
          </>
        );
      })()}
    </>
  ) : (
    <p>Click an artwork on the left to see details here!</p>
  )
      ) : infoTab === "commissions" ? (
        <div className="commission-panel">
          {/* Left side - Form */}
          <div className="commission-left">
            <section className="commission-section">
              <h2>Commissions</h2>
              <p>I love painting pets! Choose a size and add-on. This form SHOULD generate an email on your phone or pc.</p>
              <ul>
                <li>8" x 10" — $70</li>
                <li>11" x 14" — $100</li>
                <li>16" x 20" — $150</li>
                <li>20" x 24" — $200</li>
              </ul>
              <p>Add-ons:</p>
              <ul>
                <li>Extra Pet (Collage) — $40</li>
                <li>Mini Photo Print of Artwork — $5</li>
              </ul>
            <form className="commission-form" onSubmit={handleSubmit}>
              <label>Name: <input type="text" name="name" required /></label>
              <label>Email: <input type="email" name="email" required /></label>
              <label>Size: 
                <select name="size" required>
                  <option value="8x10">8" x 10"</option>
                  <option value="11x14">11" x 14"</option>
                  <option value="16x20">16" x 20"</option>
                  <option value="20x24">20" x 24"</option>
                </select>
              </label>
              <label>Notes: <textarea name="notes"></textarea></label>
              <button type="submit">Submit Commission Request</button>
            </form>

            <p style={{ fontSize: "0.9em", marginTop: "10px" }}>
              If this form doesn't work on your device, you can also email me directly at{" "}
              <a href="mailto:info@l8nart.com">info@l8nart.com</a>
            </p>
              <p>Once submitted, I will reach out a.s.a.p. (2-3 Business days)</p>

            </section>
          </div>

          {/* Right side - Sample Images */}
<div className="commission-right">
  <h3>Commission Samples (2025)</h3>
  <div className="commission-examples">
    <div className="example-pair">
      <img
        src="/art/commissions/Sample1.jpg"
        alt="Sample Commission 1"
        className="commission-example"
        onClick={() => setModalImage("/art/commissions/Sample1.jpg")}
      />
      <img
        src="/art/commissions/Sample1_orig.jpg"
        alt="Sample Commission Orig"
        className="commission-example"
        onClick={() => setModalImage("/art/commissions/Sample1_orig.jpg")}
      />
    </div>
    <div className="example-pair">
      <img
        src="/art/commissions/Sample3.jpg"
        alt="Sample Commission 3"
        className="commission-example"
        onClick={() => setModalImage("/art/commissions/Sample3.jpg")}
      />
      <img
        src="/art/commissions/Sample3_orig.jpg"
        alt="Sample Commission 3 Orig"
        className="commission-example"
        onClick={() => setModalImage("/art/commissions/Sample3_orig.jpg")}
      />
    </div>
  </div>
</div>
        </div>
      ) : (
            // Support Cats tab
            <section className="support-section">
              <h2>Support the Cats</h2>
             
              <p>
                A portion of all artwork sales helps support{" "}
                <strong>Cats of West Central Illinois Inc</strong>, a local 501c3 rescue focused on helping stray
                and surrendered cats find loving homes.
              </p>

              <h3>Ways to Help</h3>

              <ul>
                <li>💛 Buy artwork — 10% of proceeds help fund 501c3</li>

                <li>🧵 Cat quilts — $10 each</li>
                 <a
                href="https://www.paypal.com/ncp/payment/D6RU69VURFZYE"
                target="_blank"
                rel="noopener noreferrer"
                className="buy-button"
              >              <img
                src="/art/CATS_Quilt.jpg"
                alt="Cats of WC Quilt Image"
                className="cats-logo"
              />
                PayPal Checkout Link for Cat Quilt Purchases
              </a>

                <li>💰 Donate directly</li>
              </ul>

              <a
                href="https://catsofwc.org"
                target="_blank"
                rel="noopener noreferrer"
                className="buy-button"
              >              <img
                src="/art/CATS_Logo.jpg"
                alt="Cats of WC Logo"
                className="cats-logo"
              />
                Visit Cats of WC
              </a>

              <p style={{ marginTop: "15px", fontStyle: "italic" }}>
                Every bit helps — thank you for supporting the cats 🐱
              </p>
            </section>
          )
        }
        </div>
      </div>


      <footer className="app-footer">
        <p>&copy; {new Date().getFullYear()} L8NART</p>
        <p>Contact: <a href="mailto:info@l8nart.com">info@l8nart.com</a></p>
        <p>Follow me for updates:</p>
        <div className="social-links">
          <a href="https://www.instagram.com/l8n.art" target="_blank" rel="noopener noreferrer">
            <img src="/art/instagram-icon.png" alt="Instagram" className="social-icon" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61577117891215#" target="_blank" rel="noopener noreferrer">
            <img src="/art/facebook-icon.png" alt="Facebook" className="social-icon" />
          </a>
        </div>
      </footer>
      {/* Modal */}
      {modalImage && (
        <div className="modal" onClick={() => setModalImage(null)}>
          <SafeImage src={modalImage} alt="Full view" className="modal-image" />
        </div>
      )}
    </div>
  );
}

export default App;